<template>
    <div class="inviter-container-1-item">
        <flow-container :children="tpl.children"></flow-container>
    </div>
</template>

<script>
const {
    plugins: { ComplexComp }
} = require('@futuweb/fego-render');

export default {
    props: ['tpl'],
    name: 'inviter-container-1-children-render',

    components: {
        FlowContainer: ComplexComp.Container.Flow
    }
};
</script>

<style lang="less" scoped>
.inviter-container-1-item {
    display: flex;
    height: 100% !important;
    align-items: center;
    justify-content: center;
}
</style>
